import gql from 'graphql-tag';

export const GET_SIGNED_STATIC_MAP_URL = gql`
  query signStaticMapUrl($url: String!) {
    store {
      signStaticMapUrl(url: $url)
    }
  }
`;
